import { combineReducers } from 'redux';

import authReducer from './authReducer';
import languageReducer from './languageReducer';
import disableButtonsReducer from './disableButtonsReducer';
import toggleModalReducer from './toggleModalReducer';
import stationsReducer from './stationsReducer';
import commentsReducer from './commentsReducer';
import usersReducer from './usersReducer';

const mainReducer = combineReducers({
    authError: authReducer,
    language: languageReducer,
    disableButtons: disableButtonsReducer,
    modalState: toggleModalReducer,
    stations: stationsReducer,
    comments: commentsReducer,
    users: usersReducer
});

export default mainReducer;
